// Función para formatear número como moneda
export const formatMoneyInput = (value) => {
  if (!value && value !== 0) return '';
  const num = typeof value === 'string' ? parseFloat(value.replace(/[^\d.-]/g, '')) : value;
  if (isNaN(num)) return '';
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
};

// Función para parsear moneda a número
export const parseMoneyInput = (value) => {
  if (!value) return '';
  // Remover todo excepto números, comas y puntos
  const cleaned = value.replace(/[^\d,.-]/g, '');
  // En formato argentino: punto es separador de miles, coma es decimal
  const normalized = cleaned.replace(/\./g, '').replace(',', '.');
  return normalized;
};

export const getErrorMsg = (err, fallback) => {
  const detail = err.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(', ');
  if (typeof detail === 'string') return detail;
  return fallback;
};
